import { TFunc } from 'libs/i18n';
import { Pressed, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { styled } from 'libs/ui/styled';

import { DocumentsListItem } from '../types';

import { renderDownload } from './download';

const TypographyStyled = styled(Typography)(() => ({
  wordWrap: 'break-word',
  overflowWrap: 'anywhere',
  whiteSpace: 'normal',
}));

export const renderName = (
  item: DocumentsListItem,
  t: TFunc,
  onClickPreview: () => void
) => (
  <Stack className="ellipsisText" direction="row" spacing={10}>
    <Icon.DocumentLinear />
    <Pressed className="ellipsisText" onClick={onClickPreview}>
      <Typography className="ellipsisText" title={item.name}>
        {item.name}
      </Typography>
    </Pressed>
  </Stack>
);

export const renderNameMobile = (
  item: DocumentsListItem,
  t: TFunc,
  onDownload: () => void,
  onClickPreview: () => void
) => (
  <Stack
    alignItems="center"
    direction="row"
    justifyContent="space-between"
    spacing={10}
  >
    <Pressed onClick={onClickPreview}>
      <TypographyStyled title={item.name}>{item.name}</TypographyStyled>
    </Pressed>

    {renderDownload(onDownload)}
  </Stack>
);
